import { Component } from '@angular/core';
import { ContextChange } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { SupplementaryEquipment } from '../../../../components/transport-details-legacy/model/supplementary-equipment';
import { TransportDetailsService } from '../../../../components/transport-details-legacy/service/transport-details.service';
import { AbstractWidgetComponent } from '@sdbn/common';
@Component({
    selector: 'app-supplementary-equipment-details',
    templateUrl: './supplementary-equipment-details.component.html',
    styleUrls: ['./supplementary-equipment-details.component.scss'],
    standalone: false
})
export class SupplementaryEquipmentDetailsComponent extends AbstractWidgetComponent {

  transportId: number;

  supplementaryEquipment = new Array<SupplementaryEquipment>();

  constructor(
    public translationService: TranslationService,
    private transportDetailsService: TransportDetailsService
  ) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selected-transport') {
      const selectedTransport = this.dashboardContext.context.get('selected-transport');
      if (selectedTransport != null && selectedTransport.id != null && selectedTransport.id !== this.transportId) {
        this.transportId = selectedTransport.id;
        this.loadSupplementaryEquipment();
      }
    }

    if (contextChange.key === 'transport-changed') {
      if (this.transportId != null) {
        this.loadSupplementaryEquipment();
      }
    }
  }

  onSetElementAndContext() {
    const transport = this.dashboardContext.context.get('selected-transport');
    if (transport != null && transport.id != null) {
      this.transportId = transport.id;
      this.loadSupplementaryEquipment();
    }
  }

  private loadSupplementaryEquipment() {
    this.transportDetailsService.getSupplementaryEquipment({ id: this.transportId }).subscribe(
      supplementaryEquipment => {
        this.supplementaryEquipment = new Array<any>();
        for (const rp of supplementaryEquipment) {
          this.supplementaryEquipment.push(rp);
        }
      }
    );
  }
}
